import Vue from "vue"
import isNil from 'lodash/isNil'

/**
 * Build up path
 * @param template Template can be [small, medium, large]
 * @param path
 */
const createPath = (template, path = '404.jpg') => {
    if (isNil(path)) path = '404.jpg';
    return `/imagecache/${template}/${path}`
}

Vue.imageCache = createPath
Vue.prototype.imageCache = createPath
export default createPath;
